export enum WeekDayUnit {
    WEEK = "WEEK",
    DAY = "DAY",
  }